

































































import { Component, Vue } from 'vue-property-decorator'
import { bus, zirafHTTP, setAuthHeader } from '../main'
import GlobalMixins from '../mixins'

@Component
export default class AppNavigation extends GlobalMixins {
	notifications: any[] = []
	notificationsOpen: boolean = false
	navigationOpen: boolean = false
	notificationsInterval: any = false

	toggleNotifications(): void {
		if (this.notifications.length) {
			this.notificationsOpen = !this.notificationsOpen

			if (this.notificationsOpen) {
				this.navigationOpen = false
			}
		}
	}
	toggleLinks(): void {
		this.navigationOpen = !this.navigationOpen

		if (this.navigationOpen) {
			this.notificationsOpen = false
		}
	}
	logout() {
		window.localStorage.removeItem('accessToken')

		this.$store.dispatch('setLoginMessage', 'Je bent succesvol uitgelogd.')

		this.$router.push({ name: 'login' })
	}
	getNotifications() {
		zirafHTTP.get('accounts/notifications')
			.then(response => {
				this.notifications = response.data
			})
			.catch(error => {
				this.checkIfSessionExpired(error.response.data.errorCode, () => { console.error(error) })
			})
	}

	mounted() {
		bus.$on('routeChange', () => {
			this.navigationOpen = false
		})
		bus.$on('getNotifications', () => {
			this.getNotifications()
		})

		this.getNotifications()

		this.notificationsInterval = setInterval(() => {
			this.getNotifications()
		}, 300000) // Gets notifications every 5 minutes
	}
	beforeDestroy() {
		clearInterval(this.notificationsInterval)
	}
}
